import request from "@/utils/request.js";

// http://180.167.172.122:6405/hz-smart-community/data/analyse/house/type?regionId=0
// 实有房屋_房屋类别
export const houseType = data => {
  return request({
    url: "/api/hz-smart-community/data/analyse/house/type",
    params: data || {}
  });
};
// 实有房屋 居住现状
// http://180.167.172.122:6405/hz-smart-community/data/analyse/house/live?regionId=0
export const houseLive = data => {
  return request({
    url: "/api/hz-smart-community/data/analyse/house/live",
    params: data || {}
  });
};
// 实有房屋 租住占比
// http://180.167.172.122:6405/hz-smart-community/data/analyse/house/live?regionId=0
export const houseRentlive = data => {
  return request({
    url: "/api/hz-smart-community/data/analyse/house/rentLive",
    params: data || {}
  });
};
// 实有房屋 房屋性质
// http://180.167.172.122:6405/hz-smart-community/data/analyse/house/property?regionId=0
export const houseProperty = data => {
  return request({
    url: "/api/hz-smart-community/data/analyse/house/property",
    params: data || {}
  });
};
// 实有房屋 房屋用途
// http://180.167.172.122:6405/hz-smart-community/data/analyse/house/usage?regionId=0
export const houseUsage = data => {
  return request({
    url: "/api/hz-smart-community/data/analyse/house/usage",
    params: data || {}
  });
};
// 实有房屋 编辑状态
// http://180.167.172.122:6405/hz-smart-community/data/analyse/house/status?regionId=0
export const houseStatus = data => {
  return request({
    url: "/api/hz-smart-community/data/analyse/house/status",
    params: data || {}
  });
};
// 实有房屋 房屋总数
// http://180.167.172.122:6405/hz-smart-community/data/analyse/house/count?regionId=0
export const houseCount = data => {
  return request({
    url: "/api/hz-smart-community/data/analyse/house/count",
    params: data || {}
  });
};
// 实有房屋 入住户数
export const houseinHouseNum = data => {
  return request({
    url: "/api/hz-smart-community/data/analyse/house/inHouseNum",
    params: data || {}
  });
};

// 实有房屋 居住人员
// http://180.167.172.122:6405/hz-smart-community/data/analyse/house/prisonNum?regionId=0
export const prisonNum = data => {
  return request({
    url: `/api/hz-smart-community/data/analyse/house/prisonNum`,
    params: data || {}
  });
};
// 实有房屋 居住人数
// http://180.167.172.122:6405/hz-smart-community/data/analyse/house/prisonTotalNum?regionId=0
export const prisonTotalNum = data => {
  return request({
    url: "/api/hz-smart-community/data/analyse/house/prisonTotalNum",
    params: data || {}
  });
};
// 实有房屋 地区分布
// http://180.167.172.122:6405/hz-smart-community/data/analyse/house/region?regionId=0&type=0
export const region = data => {
  return request({
    url: "/api/hz-smart-community/data/analyse/house/region",
    params: data || {}
  });
};

// 实有房屋
export const securitysave = data => {
  return request({
    url: "/api/hz-smart-community/security/facilities/save",
    data: data || {},
    method: "POST"
  });
};